import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";

import { connect } from "react-redux";
import Authentication from "./../../session/index";
import { formatter } from "src/Utils";

import "./styles.scss";
import ClientHeader from "./clientHeader";
import { Accordion, AccordionTab } from "primereact/accordion";
import { CLOUDFRONT_ENDPOINT } from "src/Service/config";

class HomePageClient extends Component {


  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { smsPricings, voicePricings, emailPricings, bannerImage } = this.props;
    // console.log(this.props)
    return (
      <>
        <ClientHeader>
          {
            (bannerImage) ? <img src={`${CLOUDFRONT_ENDPOINT}mrprmedia_banner.jpg`} style={{ width: '100%' }} /> : <section class="intro">
              <div class="sp-container container">
                <div class="intro-section">
                  <div class="p-grid">
                    <div class="p-col-12 p-md-6 contents">
                      <h1>SMS, Voice & Email</h1>
                      <h1 className="caption">Campaign Is In Your Hands</h1>
                      <p style={{ marginBottom: "0px" }}>
                        {this.props.orgName} Simplifies your daily task by
                        providing
                      </p>
                      <p style={{ marginTop: "0px" }}>
                        simple way of doing SMS, Voice & Email Campaign.
                      </p>
                    </div>
                    <div class="p-col-12  p-md-6">
                      <svg
                        id="Shapes"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          class="s2p-1"
                          d="M165.66312,239.85084c7.02927-25.41,11.549-35.6951,11.94459-44.59838a146.17181,146.17181,0,0,0-40.0489-34.552c5.35492,32.0309-3.26477,51.34473-3.26477,51.34473,4.83914-20.844.17058-43.50828-2.925-54.852-36.36987-19.6941-72.0861-22.5303-72.0861-22.5303.18669,13.62272.9089,26.16341,2.12791,37.76938,15.30186,12.31606,36.58052,24.22294,36.58052,24.22294-11.06409-3.032-25.49967-10.9009-35.73949-17.01829a247.95682,247.95682,0,0,0,9.60435,44.68529c15.23847,13.21652,46.32286,27.76038,46.32286,27.76038-13.53493-2.66485-32.37163-11.92779-42.65-17.35656a171.22673,171.22673,0,0,0,34.696,55.48677A335.407,335.407,0,0,0,143.16394,301.013c-7.81163-.12017-17.60558-1.99388-26.64469-4.23,16.892,16.92366,36.83711,31.75839,58.89633,48.41586l22.42387,8.05581,7.49409-33.46561c6.94709-51.332-3.31108-88.50741-21.10162-115.4161C176.01548,213.18215,165.66312,239.85084,165.66312,239.85084Z"
                        />
                        <path
                          class="s2p-1"
                          d="M194.25263,346.2422a133.561,133.561,0,0,0-9.28079-24.78727c-3.7693-7.90845-7.95809-15.55419-12.329-23.06373-8.70661-15.04922-18.11922-29.58536-27.5776-44.08944-9.44771-14.51312-19.29286-28.73912-28.15065-43.76969-4.43435-7.50785-8.77373-15.09467-12.84983-22.86773-4.10056-7.75288-7.93109-15.70009-11.34608-23.87132l.35739-.22716c8.78491,15.06324,17.94031,29.74311,27.2282,44.36269,9.317,14.58727,18.27781,29.48553,27.4447,44.2456,9.13143,14.78371,18.23228,29.62206,26.6304,44.98589,4.15835,7.7081,8.13377,15.55273,11.68266,23.65215a135.66077,135.66077,0,0,1,8.58282,25.30249Z"
                        />
                        <path
                          class="s2p-2"
                          d="M159.72554,272.74027c-.18945-.252-.58984-.48779-1.86132.36719-1.272.85546-1.20411,1.314-1.04248,1.585l.15722.21484.21045.04736a.63088.63088,0,0,0,.13819.01465,3.04423,3.04423,0,0,0,1.38476-.59961c.47168-.3164,1.04785-.77978,1.11719-1.189l.02539-.26856Z"
                        />
                        <path
                          class="s2p-2"
                          d="M150.3022,276.6138l-.185.04981c-2.36621.64209-2.79248.75781-2.69532,1.34717l.05323.2417.1875.12158a1.22823,1.22823,0,0,0,.62744.1206,10.998,10.998,0,0,0,2.26855-.37549c.023-.00634,2.32373-.63085,2.63086-1.24267l.104-.231-.08057-.207C152.99947,275.88724,152.58736,275.99808,150.3022,276.6138Z"
                        />
                        <path
                          class="s2p-2"
                          d="M140.47261,277.544c-2.3789-.15527-2.94726-.17139-3.03759.42871v.00049l-.02149.24658.13721.1709c.40039.49707,2.57471.6543,2.82031.6709.09815.00635.50342.03222.98487.03222a3.63544,3.63544,0,0,0,1.90283-.32666l.17285-.18066-.0044-.21924C143.415,277.76761,142.90084,277.711,140.47261,277.544Z"
                        />
                        <path
                          class="s2p-2"
                          d="M130.86177,275.60257c-2.41943-.7998-2.84814-.84423-3.06005-.31689h.00048l-.07763.23047.09082.19677c.25146.54395,2.18408,1.20606,2.56836,1.333a10.20995,10.20995,0,0,0,2.43847.53711.91618.91618,0,0,0,.41993-.07568l.21093-.12744.05469-.209C133.64986,276.626,133.27877,276.40628,130.86177,275.60257Z"
                        />
                        <path
                          class="s2p-2"
                          d="M121.90133,271.50492c-2.57227-1.47071-2.77539-1.15869-2.97168-.856l-.12012.21.05078.20947c.03467.14258.12646.52149,2.28564,1.75684a6.62505,6.62505,0,0,0,2.51319,1.105.49566.49566,0,0,0,.15967-.0249l.22949-.07959.09619-.19238C124.3066,273.31107,124.47359,272.97757,121.90133,271.50492Z"
                        />
                        <path
                          class="s2p-2"
                          d="M113.80953,265.857c-2.27783-1.90674-2.53027-1.62988-2.77734-1.36377l-.15333.186.01416.21338c.00928.14649.03467.53467,1.94092,2.13086,1.68213,1.40723,2.18164,1.53906,2.376,1.53906a.52392.52392,0,0,0,.06348-.00439l.23925-.0376.12891-.17041C115.86031,268.06156,116.08638,267.76322,113.80953,265.857Z"
                        />
                        <path
                          class="s2p-2"
                          d="M104.167,257.19828l-.17676.16455-.01562.21142c-.01123.14649-.04.53516,1.60986,2.38672,1.65039,1.85254,2.03955,1.86768,2.18652,1.87354h.24219l.15381-.14893c.26172-.25342.53272-.51514-1.44726-2.73633C104.73922,256.7266,104.44869,256.96585,104.167,257.19828Z"
                        />
                        <path
                          class="s2p-2"
                          d="M98.17623,249.16556l-.001.00049-.18848.14355-.0371.208c-.02588.14453-.09473.52832,1.34716,2.542,1.44239,2.01465,1.82764,2.07276,1.97266,2.09522l.23828.02588.168-.12744c.30615-.23145.59521-.45069-1.14258-2.87891C98.7983,248.751,98.49605,248.94779,98.17623,249.16556Z"
                        />
                        <path
                          class="s2p-2"
                          d="M92.81588,240.69584l-.19532.13134-.0498.20313c-.03516.14258-.12842.52051,1.168,2.62744,1.29687,2.106,1.67724,2.19287,1.82031,2.22559l.2334.04345.17627-.1123c.32666-.208.63525-.40479-.93506-2.95459C93.46285,240.30912,93.14693,240.49564,92.81588,240.69584Z"
                        />
                        <path
                          class="s2p-2"
                          d="M89.04976,234.18753l-.21338.15088-.05566.2002a2.57748,2.57748,0,0,0,.47461,1.54687c.27734.48536.69141,1.08692,1.08984,1.19483l.25928.05029.17969-.103c.28271-.16211.56836-.53564-.208-1.89648C89.79879,233.97123,89.332,234.0264,89.04976,234.18753Z"
                        />
                        <path
                          class="s2p-3"
                          d="M379.94856,288.84828c-3.52693-18.00806-6.11659-25.38612-5.91768-31.58592a101.73872,101.73872,0,0,1,29.63088-21.84888c-5.41963,21.94427-.46476,35.80621-.46476,35.80621-2.24983-14.72282,2.19536-30.20327,4.94691-37.911a140.89511,140.89511,0,0,1,51.225-11.80226c-.854,9.44407-2.02212,18.10874-3.48529,26.09831-11.27426,7.73345-26.67457,14.86509-26.67457,14.86509,7.83957-1.51579,18.27614-6.209,25.70777-9.90987a172.58384,172.58384,0,0,1-9.04163,30.50027c-11.27815,8.36173-33.62376,16.80194-33.62376,16.80194,9.53479-1.1296,23.09982-6.55624,30.52155-9.77714a119.17777,119.17777,0,0,1-27.02936,36.662,233.45161,233.45161,0,0,1-23.43345,5.74354c5.42756.332,12.32408-.44748,18.716-1.51864-12.62285,10.8465-27.25338,20.08095-43.448,30.46794L351.58787,365.838l-3.42113-23.62324c-2.09139-35.99319,7.00461-61.247,20.782-78.97516C374.18238,269.79,379.94856,288.84828,379.94856,288.84828Z"
                        />
                        <path
                          class="s2p-3"
                          d="M354.45,361.16217a92.96154,92.96154,0,0,1,7.75892-16.7085c3.03641-5.28792,6.35-10.37121,9.78267-15.3503,6.84259-9.981,14.14784-19.5683,21.48315-29.131,7.32839-9.5695,14.91733-18.91861,21.86384-28.87858,3.47664-4.97454,6.89158-10.00893,10.13371-15.18658,3.258-5.16233,6.339-10.47389,9.1435-15.963l-.23595-.17664c-6.89767,9.98652-14.03207,19.68729-21.2552,29.33917-7.24163,9.62791-14.25259,19.49059-21.39923,29.2464-7.12328,9.77411-14.22825,19.58775-20.87348,29.80346-3.29575,5.12818-6.47181,10.36085-9.36542,15.793a94.4234,94.4234,0,0,0-7.30194,17.10319Z"
                        />
                        <path
                          class="s2p-2"
                          d="M351.30025,296.66654c-2.69726-1.252-2.86133-.93018-3.0332-.59033l-.09668.21923.06933.20118c.04786.13818.17481.50634,2.41993,1.5498a7.4644,7.4644,0,0,0,2.53418.88574.52841.52841,0,0,0,.21-.03662l.2207-.09521.083-.19483.001-.00244C353.85006,298.26664,353.99654,297.919,351.30025,296.66654Z"
                        />
                        <path
                          class="s2p-2"
                          d="M360.52,300.23636c-2.835-.86621-2.96094-.5122-3.085-.16992l-.06739.231.09668.19043c.06543.13134.24121.479,2.61133,1.20312a9.65012,9.65012,0,0,0,2.46094.53858.67525.67525,0,0,0,.37793-.07764l.20605-.12793.05274-.208v-.00342C363.25924,301.46292,363.3481,301.10111,360.52,300.23636Z"
                        />
                        <path
                          class="s2p-2"
                          d="M370.14791,302.23832c-2.93946-.32422-3.002.04443-3.06055.39746l-.02734.24121.12988.17285c.08789.11719.32227.42871,2.792.70019a17.09882,17.09882,0,0,0,1.80567.12207c.83691,0,.99511-.13378,1.07031-.19775l.17871-.16455.01172-.21826C373.06588,302.93216,373.08345,302.56107,370.14791,302.23832Z"
                        />
                        <path
                          class="s2p-2"
                          d="M379.98385,302.38626c-2.95118.22168-2.94336.59522-2.93653.95948l.02051.24023.15918.14356c.08105.07373.26367.23828,1.38769.23828.377,0,.86133-.01856,1.48243-.06543,2.47168-.186,2.71875-.48779,2.81152-.60108l.14648-.19384-.02636-.21241C382.98385,302.53421,382.93209,302.16214,379.98385,302.38626Z"
                        />
                        <path
                          class="s2p-2"
                          d="M392.83443,300.9766c-.10254-.34912-.209-.71045-3.06933-.01026-2.63477.56446-2.8711.83887-2.78125,1.33252l.05664.231.1748.11719a1.26031,1.26031,0,0,0,.64258.11865,12.21629,12.21629,0,0,0,2.24219-.31592c2.41015-.58984,2.60644-.92627,2.68066-1.05273l.1123-.21289-.05761-.20459Z"
                        />
                        <path
                          class="s2p-2"
                          d="M399.04635,297.78763c-2.6836,1.23438-2.54883,1.58057-2.41993,1.915l.10059.22168.20019.08154a.51351.51351,0,0,0,.21778.04,7.50761,7.50761,0,0,0,2.53711-.877c2.25781-1.03809,2.38183-1.40772,2.42773-1.54688l.06836-.23535-.10254-.189C401.90865,296.87943,401.72506,296.5557,399.04635,297.78763Z"
                        />
                        <path
                          class="s2p-2"
                          d="M407.50826,292.816c-2.02734,1.53272-2.30664,1.85987-1.99609,2.33155l.14648.19677.21387.03711a.48463.48463,0,0,0,.07715.00586,7.29327,7.29327,0,0,0,2.4746-1.35693c.32325-.24317,1.9375-1.48633,2-2.08545l.01465-.248-.1416-.16162C409.93111,291.10843,409.53853,291.28959,407.50826,292.816Z"
                        />
                        <path
                          class="s2p-2"
                          d="M417.00826,284.15287c-.47949-.34034-.83008.001-2.40332,1.90283-1.54492,1.87451-1.83692,2.31543-1.40918,2.72314l.18848.15918.21777-.01269c.60937-.03614,1.91992-1.59082,2.17578-1.90186.25684-.31055,1.53418-1.89209,1.45215-2.5l-.04395-.2456Z"
                        />
                        <path
                          class="s2p-2"
                          d="M421.77681,275.36039l-.208-.07129c-.57032-.19629-.82129.31152-1.792,2.48144-.96972,2.17774-1.17871,2.70264-.64843,2.99219l.22461.10742.209-.06982c.60547-.20215,1.50391-2.18506,1.60352-2.40967.10058-.2251.97558-2.2168.7207-2.80469Z"
                        />
                        <path
                          class="s2p-2"
                          d="M422.87545,261.49759a.87328.87328,0,0,0,.10937-.00781l.24512-.04736.127-.18213c.377-.54248-.13476-2.79737-.15722-2.89209-.05469-.24024-.54883-2.35694-1.11133-2.67529l-.22461-.11426-.21.06885c-.56739.18457-.47266.69531.06347,3.05908C422.21627,260.878,422.35885,261.49759,422.87545,261.49759Z"
                        />
                        <path
                          class="s2p-2"
                          d="M419.936,251.99271a.59567.59567,0,0,0,.252-.06494l.21972-.11865.06641-.21094c.19434-.61768-.88965-2.502-1.0127-2.71387-.124-.21289-1.22656-2.08447-1.86035-2.2207l-.249-.04248-.17871.12793c-.50195.35693-.21875.8457.97363,2.90039C419.16744,251.40042,419.52974,251.99271,419.936,251.99271Z"
                        />
                        <path
                          class="s2p-2"
                          d="M411.98775,242.14652c1.38965,1.20117,1.9375,1.67529,2.30371,1.67529a.49593.49593,0,0,0,.34864-.1665l.17382-.18311-.00488-.22265c-.01269-.67774-1.75195-2.18946-1.82519-2.25245-.07422-.06445-1.79493-1.583-2.49512-1.48437l-.252.04346-.124.18359c-.33594.4834-.00879.76807,1.78809,2.33106Z"
                        />
                        <path
                          class="s2p-2"
                          d="M403.14888,237.17875l.94532.31152a9.18074,9.18074,0,0,0,2.07422.56689.47107.47107,0,0,0,.48339-.31738l.09668-.23682-.08886-.20849c-.27637-.64844-2.52832-1.39356-2.54981-1.40039-.62988-.209-2.37988-.68457-2.88476-.38819l-.2168.14014-.043.22119C400.85689,236.42533,401.2524,236.55521,403.14888,237.17875Z"
                        />
                        <path
                          class="s2p-2"
                          d="M391.7651,236.67679a15.38855,15.38855,0,0,0,1.67578-.17627l1.27148-.1665c1.84082-.23731,2.27832-.29346,2.27832-.85352l-.01465-.25683-.1709-.15039c-.44628-.39356-2.249-.2544-2.90527-.167-.65918.085-2.43945.41456-2.76855.91309l-.13379.22314.06054.21729C391.1401,236.56205,391.312,236.67679,391.7651,236.67679Z"
                        />
                        <path
                          class="s2p-2"
                          d="M382.58834,241.32523a.49849.49849,0,0,0,.34179.15088c.29786,0,.67676-.29834,1.39161-.86084.27343-.21582.58691-.46289.92773-.71875.30273-.23047.59375-.44385.85449-.63526,1.13574-.83349,1.47852-1.085,1.23145-1.55224l-.13379-.22754-.22852-.05273c-.543-.12793-1.91406.70312-2.6416,1.25537-.78418.59033-1.89844,1.66845-1.91894,2.21728l.001.27Z"
                        />
                        <path
                          class="s2p-2"
                          d="M378.70845,250.41507l.23243.00977c.0166.001.03418.00146.0498.00146.47949,0,.57813-.44043.84961-1.65722.0752-.33741.16113-.72266.26172-1.13086.10547-.44043.2168-.8501.3125-1.20264.31055-1.14941.42773-1.57959-.03418-1.792l-.25-.103-.21777.102c-.50586.23731-1.0586,1.68506-1.28809,2.63526-.23437.95214-.416,2.49023-.08691,2.92871Z"
                        />
                        <path
                          class="s2p-2"
                          d="M379.19967,254.4097l-.25391.06006-.11816.19971c-.27833.47168.09765,2.02588.40039,2.89355.30078.87061.96679,2.32569,1.47558,2.52295l.249.08447.20019-.10888c.48242-.25342.33691-.66162-.19629-2.167l-.58008-1.67383C379.86568,254.71244,379.72115,254.30423,379.19967,254.4097Z"
                        />
                        <path
                          class="s2p-2"
                          d="M387.4897,267.56888l.25489-.04492.124-.18652c.31836-.46582-.02051-.76416-1.42773-2.00489l-.96582-.854c-1.34082-1.19287-1.65918-1.47412-2.07813-1.11475l-.18652.17871-.00293.2295c-.00684.59863,1.2832,1.86865,1.78027,2.30664a6.36028,6.36028,0,0,0,2.44141,1.49365A.4816.4816,0,0,0,387.4897,267.56888Z"
                        />
                        <path
                          class="s2p-2"
                          d="M396.96627,271.45609l.0498-.21484c.1416-.5918-.33887-.75635-2.63867-1.54395-2.35254-.79688-2.7793-.94189-3.02539-.3999l-.0918.23486.08692.20508c.26562.62109,2.44824,1.36865,2.54,1.3999a10.138,10.138,0,0,0,2.41894.53174.9553.9553,0,0,0,.44434-.08154Z"
                        />
                        <path
                          class="s2p-2"
                          d="M406.96529,272.25736l-.01367-.21875c-.03516-.583-.48438-.63965-2.9834-.69483-2.38379-.04492-2.94727-.03369-3.00781.565l-.0127.24853.14551.166c.42188.48047,2.59766.53613,2.84375.541.042.001.1416.00244.2793.00244.66406,0,2.21777-.0415,2.583-.42187Z"
                        />
                        <path
                          class="s2p-2"
                          d="M416.686,270.52347l.10938-.22412-.07031-.20508c-.18653-.55957-.67188-.48974-3.06153.1167-2.38672.61133-2.8457.78174-2.74414,1.35742l.05567.2417.18457.12012a1.21346,1.21346,0,0,0,.61816.11719,11.19226,11.19226,0,0,0,2.26172-.3628C414.43013,271.58548,416.395,271.06205,416.686,270.52347Z"
                        />
                        <path
                          class="s2p-2"
                          d="M423.82259,266.06662a.98583.98583,0,0,0-.17175-.40789l-.17871-.18116-.22071.001h-.002c-.41742,0-.5694.26233-.70782,1.23346-2.376,1.2796-2.23707,1.61023-2.09394,1.93011l.11231.21534.2041.06982a.50848.50848,0,0,0,.18262.03076,3.90131,3.90131,0,0,0,1.39251-.45733c-.23834,2.37609-.27618,2.8172.29694,2.93585l.25.03808.18066-.13183c.54883-.39942.78516-2.69434.79492-2.79053.00416-.03729.04029-.40057.05823-.86029,1.73834-.96185,1.8501-1.30011,1.88611-1.43073l.05469-.23876-.11328-.18458C425.59029,265.58164,425.40706,265.33268,423.82259,266.06662Z"
                        />
                        <path
                          class="s2p-2"
                          d="M430.9233,261.14066c-2.28711,1.87695-2.06641,2.17822-1.85352,2.47021l.1543.18653.21289.02685a.48541.48541,0,0,0,.06836.00537c.19824,0,.70508-.13525,2.38281-1.51367,1.918-1.57568,1.94434-1.95019,1.95606-2.10986l.00683-.24365-.14551-.15821C433.46236,259.53617,433.2065,259.26566,430.9233,261.14066Z"
                        />
                        <path
                          class="s2p-2"
                          d="M440.62447,252.56937l-.1709-.13281c-.28515-.22022-.58691-.44531-2.50683,1.80322-1.92481,2.25147-1.65332,2.5083-1.38965,2.7583l.18359.15527.21484-.01123c.14649-.00781.53614-.0288,2.14649-1.91455,1.61133-1.88623,1.57226-2.27295,1.55664-2.41845Z"
                        />
                        <path
                          class="s2p-2"
                          d="M446.06978,244.14945l-.18945-.10108c-.31836-.17089-.65332-.34179-2.17481,2.1919-1.52636,2.53906-1.21582,2.74756-.91406,2.95068l.208.12207.209-.04687c.14258-.03223.52344-.11768,1.80079-2.24268,1.27734-2.12549,1.17382-2.50146,1.13476-2.64258Z"
                        />
                        <path
                          class="s2p-2"
                          d="M450.06685,234.95267l-.20019-.0708c-.35645-.12646-.69922-.249-1.78711,2.52441-1.01074,2.64307-.84278,2.86329-.42774,3.05079l.23145.085.19824-.082c.45117-.1875,1.01856-1.46534,1.415-2.5.90332-2.30469.74023-2.65918.67969-2.793Z"
                        />
                        <path
                          class="s2p-2"
                          d="M452.812,225.31644l-.206-.0459c-.36231-.083-.72754-.16162-1.47266,2.71631-.74609,2.87793-.38477,2.98584-.03223,3.09082l.2334.05371.18359-.10449c.12793-.07227.4668-.26514,1.0879-2.6582.62011-2.39453.417-2.727.33984-2.85254Z"
                        />
                        <path
                          class="s2p-2"
                          d="M454.519,215.44632l-.21-.02636c-.38379-.04639-.74023-.08741-1.19238,2.85156-.45215,2.94629-.07813,3.01367.2832,3.07812l.23633.02979.17285-.12256c.11914-.085.43555-.311.81055-2.75488.375-2.44092.13965-2.75293.05078-2.87012Z"
                        />
                        <path
                          class="s2p-2"
                          d="M455.40377,205.47269l-.209-.01123c-.39551-.02393-.75-.03662-.9707,2.93555-.22168,2.97607.14062,3.01074.52637,3.04785l.2373.00781.16016-.13525c.1123-.09473.40918-.34717.59277-2.80762.18262-2.46191-.07422-2.75439-.1709-2.86426Z"
                        />
                        <path
                          class="s2p-2"
                          d="M455.69674,195.47025l-.209-.00147c-.34375.00684-.7539-.00683-.81152,2.98487-.05664,2.99072.30859,3.00195.69531,3.01367l.23633-.00537.15137-.144c.10742-.10108.39062-.36963.4375-2.83448.04882-2.46435-.22364-2.74414-.32618-2.84961Z"
                        />
                        <path
                          class="s2p-2"
                          d="M455.60982,185.46537l-.207.0039c-.39062.00782-.75879.01563-.71387,3.01026.041,2.90576.38868,2.98925.76465,2.98925h.03418l.23535-.01513.14551-.14893c.10352-.10449.376-.38281.34082-2.84668-.03711-2.46338-.31641-2.73388-.42187-2.83545Z"
                        />
                        <path
                          class="s2p-2"
                          d="M455.29049,181.46781h.01855a.71294.71294,0,0,0,.626-.479,1.50182,1.50182,0,0,0,.10449-.61425,1.24278,1.24278,0,0,0-.32227-.86963.62958.62958,0,0,0-.46679-.18555.71759.71759,0,0,0-.627.47852,1.507,1.507,0,0,0-.10449.61621C454.53658,181.03812,454.853,181.46781,455.29049,181.46781Z"
                        />
                        <ellipse
                          class="s2p-4"
                          cx="258.17037"
                          cy="393.46537"
                          rx="198.5"
                          ry="24.5"
                        />
                        <polygon
                          class="s2p-5"
                          points="375.11 154.118 339.972 181.081 350.273 193.557 375.11 154.118"
                        />
                        <polygon
                          class="s2p-6"
                          points="375.11 154.118 348.082 181.417 350.273 193.557 375.11 154.118"
                        />
                        <polygon
                          class="s2p-2"
                          points="375.11 154.118 326.395 178 339.972 181.081 375.11 154.118"
                        />
                        <polygon
                          class="s2p-2"
                          points="375.11 154.118 348.082 181.417 364.587 183.915 375.11 154.118"
                        />
                        <path
                          class="s2p-2"
                          d="M220.65188,264.085a.69049.69049,0,0,1,.25253-.94358c1.05353-.60889,2.10037-1.27539,3.11125-1.98155a.691.691,0,1,1,.79133,1.133c-1.04387.72836-2.12418,1.41642-3.21143,2.04467a.67868.67868,0,0,1-.199.07726A.69069.69069,0,0,1,220.65188,264.085Zm7.30946-5.10165a.691.691,0,0,1,.06285-.97489,49.70238,49.70238,0,0,0,3.65288-3.56863.69082.69082,0,1,1,1.01474.93768,51.05659,51.05659,0,0,1-3.75556,3.66867.68989.68989,0,0,1-.97491-.06283Zm7.13606-7.49094a.6912.6912,0,0,1-.12829-.96839c1.01428-1.32568,2.00215-2.73782,2.93562-4.19777a.69106.69106,0,1,1,1.16434.74469c-.95484,1.4922-1.96509,2.93649-3.00295,4.29275a.69131.69131,0,0,1-.96872.12872Zm5.68311-8.65371a.691.691,0,0,1-.28007-.936c.79219-1.471,1.558-3.01978,2.274-4.60249a.69105.69105,0,0,1,1.25925.56966c-.73047,1.61183-1.50991,3.18891-2.3174,4.68788a.69129.69129,0,0,1-.93582.281Zm53.673-20.12007a.69066.69066,0,0,1,.51416-.83084c1.68389-.39666,3.363-.83073,4.99077-1.29022a.69071.69071,0,1,1,.375,1.32956c-1.64644.46525-3.34519.90438-5.04952,1.30541l-.01159.00253A.69053.69053,0,0,1,294.4535,222.71859Zm-4.26387,1.6018c-1.68306.324-3.4101.62083-5.13333.8832a.69073.69073,0,1,1-.20852-1.36564c1.70571-.25986,3.41517-.55367,5.08011-.87419a.69078.69078,0,0,1,.27746,1.35331Zm-45.04371,9.12537a.6911.6911,0,0,1-.40133-.891c.5995-1.57941,1.1655-3.21326,1.68357-4.85753a.69065.69065,0,1,1,1.31728.41565c-.52566,1.66869-1.10078,3.32824-1.70877,4.93188a.69021.69021,0,0,1-.89075.401ZM304.445,219.95441a.69095.69095,0,0,1,.43486-.87449c1.64581-.55154,3.27241-1.14446,4.83392-1.76223a.691.691,0,0,1,.50849,1.28507c-1.58472.62617-3.23437,1.22767-4.90259,1.78741-.025.008-.04932.015-.07407.02037A.69078.69078,0,0,1,304.445,219.95441Zm-24.55227,5.93434q-1.02058.11619-2.02672.21572c-1.05689.10439-2.1238.18628-3.17191.24427a.691.691,0,0,1-.07517-1.38c1.02674-.05635,2.07407-.137,3.11073-.23958q.99618-.09768,2.0066-.213a.691.691,0,0,1,.22576,1.36155A.67087.67087,0,0,1,279.89273,225.88875Zm-10.4279.55932c-1.743-.03108-3.50026-.12817-5.223-.2882a.69079.69079,0,0,1,.12763-1.37567c1.68912.15673,3.41154.25177,5.1198.28211a.69106.69106,0,0,1,.13527,1.366A.71338.71338,0,0,1,269.46483,226.44807Zm44.6369-10.2396a.68993.68993,0,0,1,.335-.91751c1.57525-.73339,3.11744-1.51221,4.58174-2.31512a.69074.69074,0,1,1,.66345,1.21175c-1.49056.81719-3.05911,1.60991-4.66263,2.3558a.67953.67953,0,0,1-.14552.04938A.6914.6914,0,0,1,314.10173,216.20847Zm9.11384-4.90357a.69047.69047,0,0,1,.20338-.95537c1.45177-.94209,2.857-1.938,4.17622-2.96045a.69063.69063,0,1,1,.84627,1.09166c-1.34946,1.04632-2.78633,2.065-4.2705,3.02762a.68938.68938,0,0,1-.95537-.20346Zm-64.16,14.17091c-1.72071-.29443-3.444-.65983-5.1209-1.08581a.69094.69094,0,0,1,.34108-1.33913c1.64123.417,3.32745.77485,5.01236,1.06362a.69052.69052,0,1,1-.23254,1.36132Zm-10.72176-1.883a.691.691,0,0,1-.49892-.83966c.01751-.07026.03582-.1406.05333-.21095-1.299-.467-2.59158-.979-3.85553-1.52642a.691.691,0,0,1,.54965-1.268c1.19163.51661,2.40913,1.00045,3.63407,1.44389.273-1.16726.518-2.32417.73083-3.45425a.69119.69119,0,0,1,1.35855.25561c-.227,1.20387-.4901,2.43683-.78358,3.68012a.69141.69141,0,0,1,.27058.79779.68135.68135,0,0,1-.5791.46444c-.01293.05231-.02638.10529-.04.158a.69027.69027,0,0,1-.83991.49946Zm83.12124-18.54153a.69126.69126,0,0,1,.03119-.9768,49.29177,49.29177,0,0,0,3.54013-3.677.69093.69093,0,0,1,1.04467.90456,51.00962,51.00962,0,0,1-3.63929,3.78056.6908.6908,0,0,1-.9767-.03132Zm6.8688-7.72715a.691.691,0,0,1-.17829-.96055,43.21412,43.21412,0,0,0,2.63243-4.36464.6908.6908,0,0,1,1.22326.64222,44.56258,44.56258,0,0,1-2.71677,4.50455.69149.69149,0,0,1-.96063.17842ZM239.31836,218.738c-1.5317-.81906-3.0501-1.71181-4.51175-2.653a.69115.69115,0,0,1,.74882-1.1619c1.42957.92146,2.91547,1.795,4.415,2.5964a.691.691,0,0,1-.652,1.21854Zm11.0084-5.30716a.69082.69082,0,0,1-.60715-.76516c.19761-1.72511.325-3.44418.37614-5.10823a.691.691,0,1,1,1.38132.04253c-.05322,1.70263-.18261,3.46-.38557,5.22355a.68936.68936,0,0,1-.76474.60731Zm-19.79945-.35882c-1.37366-1.05267-2.7272-2.17921-4.02141-3.34748a.6906.6906,0,1,1,.92494-1.02576c1.26757,1.14394,2.59233,2.246,3.937,3.277a.6907.6907,0,0,1-.84057,1.09622Zm20.22248-9.98246a.69085.69085,0,0,1-.73294-.64557,47.93052,47.93052,0,0,0-.58989-5.0699.668.668,0,0,1,.56373-.79806.6899.6899,0,0,1,.79727.564,49.312,49.312,0,0,1,.60763,5.216.69143.69143,0,0,1-.54185.71916A.76167.76167,0,0,1,250.74979,203.0896Zm-27.9854,2.97552c-1.18766-1.25747-2.34545-2.5836-3.44093-3.94132a.69068.69068,0,1,1,1.07492-.8676c1.0741,1.33,2.20774,2.62907,3.37,3.861a.69041.69041,0,1,1-1.004.948Zm25.50636-13.655-.05881-.19527a35.1099,35.1099,0,0,0-1.737-4.555.691.691,0,0,1,1.255-.57872,36.55131,36.55131,0,0,1,1.80375,4.73072l.06217.207a.69066.69066,0,0,1-.46695.85814c-.017.00507-.03338.00906-.04989.01256A.691.691,0,0,1,248.27075,192.41008Zm-32.07628,5.52046c-.98069-1.42492-1.92439-2.91015-2.8043-4.41476a.691.691,0,0,1,1.19318-.69736c.86214,1.47524,1.78744,2.93158,2.74919,4.32827a.69095.69095,0,1,1-1.13807.78385Zm27.847-14.73833a38.128,38.128,0,0,0-3.00235-4.10692.69105.69105,0,0,1,1.05829-.88895,39.56634,39.56634,0,0,1,3.11088,4.25664.69064.69064,0,1,1-1.16682.73923ZM210.91617,188.909l-.38065-.78336a20.81255,20.81255,0,0,1-1.48056-4.20469.69039.69039,0,0,1,.51429-.83044l.01158-.00254a.6905.6905,0,0,1,.81889.51694,19.415,19.415,0,0,0,1.38188,3.9241l.37458.77168a.69059.69059,0,1,1-1.24.60831Zm26.588-13.47007a30.2867,30.2867,0,0,0-4.04146-3.04211.6909.6909,0,0,1,.733-1.17135,31.75259,31.75259,0,0,1,4.22674,3.18051.69105.69105,0,1,1-.91828,1.03295Zm-28.27429,3.87053a.69062.69062,0,0,1-.64009-.73813,12.67488,12.67488,0,0,1,1.472-5.23148.69107.69107,0,0,1,1.21242.66359,11.3099,11.3099,0,0,0-1.30647,4.66646.69127.69127,0,0,1-.54236.626A.67762.67762,0,0,1,209.22992,179.30942Zm19.72875-9.16042a22.05889,22.05889,0,0,0-4.85488-1.23617.69108.69108,0,0,1,.184-1.36985,23.459,23.459,0,0,1,5.15828,1.31363.69063.69063,0,1,1-.48745,1.29239Zm-15.34948.17307a.691.691,0,0,1,.21873-.95219,13.4787,13.4787,0,0,1,5.10086-1.84818.69061.69061,0,1,1,.21008,1.36516,12.11047,12.11047,0,0,0-4.577,1.65348.69026.69026,0,0,1-.95264-.21827Z"
                        />
                        <path
                          class="s2p-7"
                          d="M413.38021,181.70153l7.16146-28.49871a2.62356,2.62356,0,0,1,2.65551-1.98183l28.56244,1.20951"
                        />
                        <polygon
                          class="s2p-8"
                          points="413.38 181.702 451.76 152.43 472.545 177.859 432.309 207.507 413.38 181.702"
                        />
                        <path
                          class="s2p-9"
                          d="M432.30853,207.50714c-.08205-.009.47332-5.703,1.24021-12.71635.76727-7.01577,1.45549-12.694,1.53752-12.685.08208.009-.47319,5.70179-1.24032,12.71758C433.079,201.83658,432.39061,207.51608,432.30853,207.50714Z"
                        />
                        <path
                          class="s2p-9"
                          d="M472.54529,177.85879c-.01644.08093-5.50785-.96378-12.264-2.33313-6.75845-1.36977-12.22215-2.54544-12.20578-2.62633.01639-.08081,5.50673.96364,12.2652,2.3334C467.09677,176.602,472.56168,177.77794,472.54529,177.85879Z"
                        />
                        <polyline
                          class="s2p-10"
                          points="451.76 152.43 444.011 182.468 413.38 181.702"
                        />
                        <polygon
                          class="s2p-11"
                          points="416.401 181.675 407.286 169.668 440.776 143.883 450.684 156.278 443.857 182.267 416.401 181.675"
                        />
                        <path
                          class="s2p-12"
                          d="M148.864,231.96537H359.217a14.5673,14.5673,0,0,1,14.5673,14.5673V375.76879a14.5673,14.5673,0,0,1-14.5673,14.5673H148.86407a14.5673,14.5673,0,0,1-14.5673-14.5673V246.53257A14.5672,14.5672,0,0,1,148.864,231.96537Z"
                        />
                        <path
                          class="s2p-12"
                          d="M124.93711,380.10808H384.40363a0,0,0,0,1,0,0v0a13.85728,13.85728,0,0,1-13.85728,13.85728h-231.752a13.85727,13.85727,0,0,1-13.85727-13.85727v0A0,0,0,0,1,124.93711,380.10808Z"
                        />
                        <rect
                          class="s2p-13"
                          x="140.72522"
                          y="238.25742"
                          width="225.96096"
                          height="133.74188"
                        />
                        <polygon
                          class="s2p-13"
                          points="230.432 378.623 233.652 383.744 278.958 383.744 281.948 378.623 230.432 378.623"
                        />
                        <path
                          class="s2p-14"
                          d="M148.65186,242.78513H359.22333a3.2734,3.2734,0,0,1,3.2734,3.2734V368.29845a3.2729,3.2729,0,0,1-3.2729,3.2729h-210.572a3.2725,3.2725,0,0,1-3.2725-3.2725V246.05763A3.2725,3.2725,0,0,1,148.65186,242.78513Z"
                        />
                        <polygon
                          class="s2p-15"
                          points="362.114 371.76 144.996 371.76 145.229 252.41 362.114 252.41 362.114 371.76"
                        />
                        <path
                          class="s2p-13"
                          d="M163.18638,247.75878a1.73389,1.73389,0,1,1-1.73408-1.73377A1.73405,1.73405,0,0,1,163.18638,247.75878Z"
                        />
                        <path
                          class="s2p-13"
                          d="M152.67716,247.75878a1.734,1.734,0,1,1-1.73408-1.73377A1.73389,1.73389,0,0,1,152.67716,247.75878Z"
                        />
                        <path
                          class="s2p-13"
                          d="M157.72163,247.75878a1.734,1.734,0,1,1-1.734-1.73377A1.73388,1.73388,0,0,1,157.72163,247.75878Z"
                        />
                        <path
                          class="s2p-13"
                          d="M371.72635,378.62282c0,.08582-53.15472.15527-118.70906.15527-65.57726,0-118.72052-.06945-118.72052-.15527,0-.08552,53.14326-.155,118.72052-.155C318.57163,378.46786,371.72635,378.5373,371.72635,378.62282Z"
                        />
                        <path
                          class="s2p-9"
                          d="M66.11618,311.82871l26.83808-7.3176a2.48367,2.48367,0,0,1,2.86766,1.27129l12.25814,24.1283"
                        />
                        <polygon
                          class="s2p-16"
                          points="66.116 311.829 108.08 329.911 96.746 358.863 53.609 339.423 66.116 311.829"
                        />
                        <path
                          class="s2p-9"
                          d="M53.60872,339.42316c-.03065-.07187,4.92522-2.25627,11.06789-4.87848,6.14483-2.623,11.14932-4.69046,11.18-4.61863.03068.07189-4.92417,2.25582-11.069,4.879C58.64507,337.42707,53.63944,339.495,53.60872,339.42316Z"
                        />
                        <path
                          class="s2p-9"
                          d="M96.74593,358.86254c-.0744.024-1.761-4.99184-3.76678-11.20191-2.00646-6.21214-3.57217-11.26591-3.49783-11.28994s1.76062,4.99085,3.76711,11.203C95.2542,353.78367,96.82026,358.83854,96.74593,358.86254Z"
                        />
                        <polyline
                          class="s2p-10"
                          points="108.08 329.911 79.7 337.458 66.116 311.829"
                        />
                        <polygon
                          class="s2p-11"
                          points="67.54 314.309 73.217 301.215 110.035 316.881 104.406 330.809 79.794 337.238 67.54 314.309"
                        />
                        <rect
                          class="s2p-17"
                          x="427.09572"
                          y="301.1897"
                          width="35.45267"
                          height="52.5978"
                          transform="translate(-21.05607 624.25957) rotate(-68.8591)"
                        />
                        <path
                          class="s2p-18"
                          d="M462.96811,353.52975l-.01658-.00622-49.07418-18.97662.00622-.01623,12.7926-33.08334.01624.00622,49.07417,18.97662-.00622.01623ZM413.923,334.52688l49.02443,18.95727,12.7736-33.03394-49.02477-18.95727Z"
                        />
                        <path
                          class="s2p-18"
                          d="M475.7473,320.89849a3.65479,3.65479,0,0,1-.62692.26354c-.46121.16867-1.069.39082-1.82873.66852-1.64443.57837-3.94089,1.38612-6.76,2.37767-5.76955,1.9805-13.66682,4.69133-22.41415,7.69394l-.18445.06332-.09869-.16916-.23843-.40872c-4.69125-8.097-8.93665-15.42438-12.04071-20.78182-1.5013-2.6369-2.7252-4.78627-3.60143-6.32521q-.59737-1.07951-.95831-1.73181a3.74585,3.74585,0,0,1-.306-.62026,3.76325,3.76325,0,0,1,.38912.5718q.39139.63727,1.03571,1.68667c.90807,1.52026,2.17653,3.64367,3.73267,6.24873,3.13505,5.33918,7.423,12.64181,12.16148,20.71135l.23829.40865-.28286-.1057c8.76509-2.95,16.67849-5.61355,22.45971-7.55937,2.83946-.932,5.15248-1.691,6.80865-2.23462.7716-.24274,1.389-.437,1.85732-.58439A3.65592,3.65592,0,0,1,475.7473,320.89849Z"
                        />
                        <path
                          class="s2p-18"
                          d="M413.90311,334.99519c-.0634-.11568,5.37844-3.22179,12.15306-6.937,6.777-3.71633,12.32053-6.63439,12.38392-6.51872.0634.11554-5.37724,3.221-12.15426,6.93749C419.51114,332.19209,413.96643,335.11072,413.90311,334.99519Z"
                        />
                        <path
                          class="s2p-18"
                          d="M454.907,327.43164c.12615-.03827,2.0315,5.87087,4.25523,13.19677,2.2245,7.32851,3.92483,13.29843,3.79868,13.33677-.12615.03821-2.03114-5.86959-4.25558-13.198C456.48164,333.44118,454.78082,327.47,454.907,327.43164Z"
                        />
                        <rect
                          class="s2p-19"
                          x="49.00047"
                          y="194.66022"
                          width="52.5978"
                          height="35.45267"
                          transform="translate(-64.5158 35.66711) rotate(-18.82858)"
                        />
                        <path
                          class="s2p-18"
                          d="M105.93457,220.6875l-.0167.00588-49.8,16.98082-.00566-.01644-11.448-33.57233.01644-.00567,49.8-16.98081.00567.01644ZM56.14,237.62955l49.74943-16.96368L94.45858,187.1436,44.70889,204.10751Z"
                        />
                        <path
                          class="s2p-18"
                          d="M94.76672,187.47025a3.65478,3.65478,0,0,1-.31117.60469c-.24512.42554-.56823.98624-.97207,1.68708-.88874,1.49961-2.12983,3.59385-3.65338,6.16468-3.14949,5.22407-7.46046,12.37466-12.23548,20.29492l-.10068.167-.18431-.06624-.44528-.16008c-8.79666-3.19187-16.75724-6.08032-22.57765-8.1922-2.84447-1.05649-5.16317-1.91753-6.82329-2.53408-.76751-.29571-1.38167-.53238-1.8469-.71164a3.74593,3.74593,0,0,1-.633-.27879,3.764,3.764,0,0,1,.66553.18825c.47288.158,1.097.36661,1.87722.62733,1.67253.58178,4.00869,1.39429,6.87474,2.39115,5.83244,2.078,13.80975,4.92011,22.62494,8.06062l.44513.16011-.28468.1007c4.8224-7.89139,9.17615-15.01607,12.35684-20.22106,1.57744-2.53828,2.86249-4.60585,3.78258-6.08633q.65311-1.02254,1.048-1.641A3.65588,3.65588,0,0,1,94.76672,187.47025Z"
                        />
                        <path
                          class="s2p-18"
                          d="M56.42558,238.00121c-.12289-.04793,2.05236-5.92414,4.85777-13.1233,2.80653-7.20156,5.18049-12.999,5.30338-12.951.1228.04782-2.05193,5.92277-4.85837,13.12444C58.92285,232.25047,56.54833,238.04908,56.42558,238.00121Z"
                        />
                        <path
                          class="s2p-18"
                          d="M82.99173,205.86457c.07209-.11037,5.32824,3.19435,11.73848,7.38035,6.41252,4.1875,11.55058,7.67051,11.47853,7.78093-.07213.11031-5.32714-3.19361-11.73957-7.3811C88.05894,209.45866,82.91969,205.975,82.99173,205.86457Z"
                        />
                        <path
                          class="s2p-20"
                          d="M313.67037,327.96537a76.57307,76.57307,0,0,1-61.394,27.19567c-25.18027-1.21652-41.91483-15.45578-49.606-22.19567-9.69414-8.49512-33.76436-33.035-27.13954-45.81858,4.5523-8.78436,20.10322-5.27308,73.465-3.449,56.39654,1.92786,76.07174-.72782,80.45837,9.821C333.82686,304.03415,320.00371,320.446,313.67037,327.96537Z"
                        />
                        <polygon
                          class="s2p-21"
                          points="244.07 266.001 211.673 310.336 287.534 299.558 244.07 266.001"
                        />
                        <polygon
                          class="s2p-21"
                          points="287.534 299.558 211.673 310.336 255.643 347.449 287.534 299.558"
                        />
                        <rect
                          class="s2p-22"
                          x="228.82506"
                          y="267.08502"
                          width="53.06797"
                          height="69.80622"
                          transform="translate(80.45195 -52.71256) rotate(13.96918)"
                        />
                        <rect
                          class="s2p-23"
                          x="247.77282"
                          y="322.78323"
                          width="15.52301"
                          height="2.15016"
                          transform="translate(85.73639 -52.10799) rotate(13.96915)"
                        />
                        <rect
                          class="s2p-23"
                          x="239.63584"
                          y="280.99884"
                          width="25.444"
                          height="2.15022"
                          transform="translate(75.5555 -52.5768) rotate(13.9691)"
                        />
                        <rect
                          class="s2p-23"
                          x="238.62174"
                          y="284.30368"
                          width="12.84384"
                          height="2.15019"
                          transform="translate(76.13698 -50.71343) rotate(13.96911)"
                        />
                        <rect
                          class="s2p-23"
                          x="237.42132"
                          y="289.12934"
                          width="12.84384"
                          height="2.15022"
                          transform="translate(77.26639 -50.28094) rotate(13.96911)"
                        />
                        <rect
                          class="s2p-23"
                          x="236.2209"
                          y="293.95501"
                          width="12.84384"
                          height="2.15019"
                          transform="translate(78.39579 -49.84845) rotate(13.96911)"
                        />
                        <rect
                          class="s2p-23"
                          x="234.61689"
                          y="302.07495"
                          width="40.13709"
                          height="2.15022"
                          transform="translate(80.71204 -52.51536) rotate(13.9691)"
                        />
                        <rect
                          class="s2p-23"
                          x="233.59135"
                          y="305.47322"
                          width="28.31101"
                          height="2.15019"
                          transform="translate(81.32716 -50.73989) rotate(13.9691)"
                        />
                        <polygon
                          class="s2p-24"
                          points="287.534 299.558 255.643 347.449 211.673 310.336 218.63 359.299 294.491 348.521 287.534 299.558"
                        />
                        <path
                          class="s2p-25"
                          d="M226.59238,344.98365,218.63,359.29934,294.491,348.52107,282.8563,336.9897A35.65833,35.65833,0,0,0,226.59238,344.98365Z"
                        />
                        <path
                          class="s2p-26"
                          d="M241.05906,325.61841,218.63,359.29934,294.491,348.52107l-30.92274-26.10074A15.23628,15.23628,0,0,0,241.05906,325.61841Z"
                        />
                        <g id="refresh">
                          <path
                            class="s2p-2"
                            d="M41.38415,280.03047l-.02866-.00059a.54171.54171,0,0,1-.41788-.22556l-4.60751-6.46419a.51053.51053,0,0,1,.13776-.7277.552.552,0,0,1,.753.13423l4.20928,5.90293,4.84165-5.4598a.55571.55571,0,0,1,.76451-.05677.5104.5104,0,0,1,.05734.73863l-5.29851,5.9764A.5491.5491,0,0,1,41.38415,280.03047Z"
                          />
                          <path
                            class="s2p-2"
                            d="M74.10065,280.26461a.55475.55475,0,0,1-.45-.226l-4.20352-5.90235-4.84518,5.4564a.55643.55643,0,0,1-.76552.05618.51073.51073,0,0,1-.05868-.738l5.3043-5.97346a.55432.55432,0,0,1,.85864.0442l4.60528,6.463a.51254.51254,0,0,1-.13894.7277A.5501.5501,0,0,1,74.10065,280.26461Z"
                          />
                          <path
                            class="s2p-2"
                            d="M55.403,289.37008a14.99411,14.99411,0,0,1-10.22282-3.971.51218.51218,0,0,1-.01492-.73981.55574.55574,0,0,1,.76672-.01492,14.01824,14.01824,0,0,0,12.61281,3.33112c6.89061-1.53062,11.6313-8.18947,10.35491-14.54a.52729.52729,0,0,1,.43044-.61356.538.538,0,0,1,.63355.41386,12.61009,12.61009,0,0,1-2.32556,9.96693,15.1369,15.1369,0,0,1-8.85,5.79386A15.5313,15.5313,0,0,1,55.403,289.37008Z"
                          />
                          <path
                            class="s2p-2"
                            d="M41.38991,279.99145a.543.543,0,0,1-.52339-.38448,13.07209,13.07209,0,0,1,1.53237-10.558,15.32774,15.32774,0,0,1,9.67991-6.83786,15.13575,15.13575,0,0,1,14.28985,4.27123.51085.51085,0,0,1-.03677.7398.55545.55545,0,0,1-.76568-.035,14.02648,14.02648,0,0,0-13.244-3.95562,14.246,14.246,0,0,0-8.99239,6.35406,12.05346,12.05346,0,0,0-1.41767,9.74254.52235.52235,0,0,1-.37766.64448A.57744.57744,0,0,1,41.38991,279.99145Z"
                          />
                        </g>
                        <g id="person">
                          <rect
                            class="s2p-2"
                            x="155.78791"
                            y="149.81429"
                            width="5.48153"
                            height="0.78825"
                          />
                          <rect
                            class="s2p-2"
                            x="158.12164"
                            y="147.62652"
                            width="0.81495"
                            height="5.16291"
                          />
                          <path
                            class="s2p-2"
                            d="M149.35412,173.50427c-9.95988,0-18.06256-7.6365-18.06256-17.02218,0-9.38655,8.10268-17.02128,18.06256-17.02128,9.95892,0,18.06169,7.63473,18.06169,17.02128C167.41581,165.86777,159.313,173.50427,149.35412,173.50427Zm0-33.09554c-9.41855,0-17.08007,7.21-17.08007,16.07336s7.66152,16.07417,17.08007,16.07417c9.41848,0,17.07911-7.21082,17.07911-16.07417S158.7726,140.40873,149.35412,140.40873Z"
                          />
                          <path
                            class="s2p-2"
                            d="M156.63487,161.19862l-4.98512-1.6818v-1.42719h-.00345a5.83332,5.83332,0,0,0,2.34151-4.777c0-3.11677-2.23356-5.64208-4.992-5.64208-2.75765,0-4.99369,2.52531-4.99369,5.64208a5.78783,5.78783,0,0,0,2.58835,4.94454v1.25965l-4.986,1.6818a2.81858,2.81858,0,0,0-1.97187,2.65749v1.77251h18.97424v-1.77251A2.81868,2.81868,0,0,0,156.63487,161.19862Z"
                          />
                        </g>
                        <path
                          class="s2p-2"
                          d="M360.47494,391.33258,347.1395,364.58415a27.33274,27.33274,0,0,0,9.028-10.69611c6.79124-14.36194-.07376-31.90159-15.30334-39.10315-15.2204-7.19717-33.13579-1.37527-39.927,12.98662-6.78977,14.35874.07812,31.89974,15.29852,39.097a31.57116,31.57116,0,0,0,19.70862,2.481l13.66127,27.402a6.07263,6.07263,0,1,0,10.86935-5.4189Zm-42.90762-27.28022c-13.61468-6.43794-19.76048-22.0941-13.70592-34.89811,6.05608-12.8071,22.05645-17.99119,35.67118-11.55325,13.62071,6.44076,19.77914,22.10294,13.72306,34.91009C347.20108,365.31505,331.18809,370.49312,317.56732,364.05236Z"
                        />
                        <path
                          class="s2p-2"
                          d="M339.41364,135.25449c-2.25591.6121-5.46716.56956-9.63347-1.05655-7.84285-3.061-11.19259-10.5011-7.83092-19.11417,3.33421-8.543,11.66355-13.2398,20.94193-9.61883,7.00229,2.73324,10.95985,9.442,7.98085,17.07439-2.48708,6.37245-7.30272,8.89-11.36451,7.305-1.96018-.76514-2.94921-2.15985-1.94847-4.31068a6.036,6.036,0,0,1-6.38416,1.05846c-2.73039-1.06583-4.123-3.90822-2.51011-8.03975,2.10441-5.39182,6.84677-8.34293,10.94343-6.744,3.18569,1.24343,3.44936,3.56611,3.25122,4.90146l1.75791-2.541,1.68081.6559-6.14734,9.34017c-1.58494,2.40688-1.09339,3.52679.2721,4.05931,3.08087,1.20274,6.48718-1.21938,8.46881-6.29667,2.50041-6.40654-.26323-12.24725-6.81014-14.80219-7.91288-3.08845-15.08953.92946-18.17215,8.7236-2.76712,6.9879-.32945,13.87078,6.67284,16.604a15.57917,15.57917,0,0,0,8.8507.9945Zm-8.82513-16.15362c-1.17549,3.01191-.5295,5.07827,1.53665,5.885,2.52028.98345,5.03964.111,7.742-3.91756,2.48139-3.67132,2.20081-6.36316-.95-7.59267C335.55553,112.16384,332.20079,114.97011,330.58851,119.10087Z"
                        />
                        <path
                          class="s2p-2"
                          d="M267.87,130.18014l-8.53125-4.93848c-.21777.01514-.437.02588-.65869.02588H223.43688A8.95827,8.95827,0,0,1,214.246,116.584V102.7192a8.95875,8.95875,0,0,1,9.19092-8.68457H258.68A8.95818,8.95818,0,0,1,267.87,102.7192Zm-8.29882-5.95947,7.29882,4.2251V102.7192A7.95824,7.95824,0,0,0,258.68,95.03463H223.43688a7.95882,7.95882,0,0,0-8.19092,7.68457V116.584a7.95833,7.95833,0,0,0,8.19092,7.68359H258.68c.24756,0,.49219-.01513.73535-.03466Z"
                        />
                        <rect
                          class="s2p-2"
                          x="220.70077"
                          y="102.8187"
                          width="26.6577"
                          height="0.8911"
                        />
                        <rect
                          class="s2p-2"
                          x="249.16217"
                          y="102.8182"
                          width="11.6016"
                          height="0.8906"
                        />
                        <rect
                          class="s2p-2"
                          x="220.70077"
                          y="108.8529"
                          width="11.9478"
                          height="0.8911"
                        />
                        <rect
                          class="s2p-2"
                          x="234.41077"
                          y="108.8548"
                          width="17.4873"
                          height="0.8902"
                        />
                        <rect
                          class="s2p-2"
                          x="254.00739"
                          y="108.7503"
                          width="6.75639"
                          height="0.8911"
                        />
                        <rect
                          class="s2p-2"
                          x="220.70077"
                          y="114.8885"
                          width="4.8731"
                          height="0.8911"
                        />
                        <rect
                          class="s2p-2"
                          x="227.33647"
                          y="114.89"
                          width="20.8301"
                          height="0.8906"
                        />
                        <rect
                          class="s2p-2"
                          x="249.82239"
                          y="114.89"
                          width="11.32369"
                          height="0.8906"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          }

          <div class="sp-container container  bulk-sms-w">
            <div class="sp-container-fluid  ">
              <div class="p-grid">
                <div class="p-md-8">
                  <h1 class="title-s1 main-heading">
                    Bulk <span>SMS</span>
                  </h1>
                  <p class="text-xl">
                    Bulk SMS service or bulk message means building SMS to one
                    or more recipients via software/API/web platform as{" "}
                    {this.props.orgName} came forward to provide platform to
                    send online bulk SMS in India. Generally SMS are of two
                    types. There are Promotional SMS and Transactional SMS{" "}
                  </p>
                </div>
                <div class="col-md-6"></div>
              </div>

              <div class="p-grid sp-card1 promotional-sms">
                <div class="p-md-6">
                  <div class="sp-w70">
                    <h1 class="title-s2 main-heading ">Promotional SMS</h1>
                    <p class="sp-text1">
                      Promotional SMS is advertise a business and market its
                      products and services. Brands mainly use promotional SMS
                      to promote their products or services and generate
                      customer interest—and to drive prior engagement from
                      target consumers in a more direct and efficient way.{" "}
                    </p>
                  </div>
                </div>
                <div class="p-md-6">
                  <img
                    src="./images/promotional_crop.jpeg"
                    class="sp-center img-fluid img-thumbnail sp-thumbnail"
                    alt="Responsive image"
                  />
                </div>
              </div>
              <div class="p-grid sp-card1 transactional-sms">
                <div class="p-md-6">
                  <div class="sp-w70">
                    <h1 class="title-s2 main-heading ">Transactional SMS</h1>
                    <p class="sp-text1">
                      Transactional SMS is used by businesses to relay
                      transactional information. Through this type of SMS,
                      businesses can reach customers directly to share important
                      non-promotional information—like order status, delivery
                      notifications, alerts and OTP 24*7 to Non DND mobile
                      numbers and more..
                    </p>
                  </div>
                </div>
                <div class="p-md-6">
                  <img
                    src="./images/transactional_crop.jpeg"
                    class=" sp-center img-fluid img-thumbnail sp-thumbnail"
                    alt="Responsive image"
                  />
                </div>
              </div>
              <div class="sp-container  sp-container-fluid voice-sms-w ">
                <p class="text-xl">
                  A single SMS message can contain up to 160 characters if it's composed of standard characters, but this limit reduces to 70 characters when non GSM characters are included.
                </p>
                <p class="text-xl">
                  The 160-character limit applies to messages encoded with the GSM-7 character set, while non-GSM-7 messages are limited to 70 characters. When a message surpasses 160 characters, it's split into 153-character segments, including a data header for proper reassembly.
                </p>
                <p class="text-xl">
                  For instance, a 162-character message results in two segments: one with 153 characters and another with 8 characters. In the same way, 72 non GSM message will split into one segment with 67 characters and another one with 5 characters.
                </p>
              </div>
            </div>
          </div>
          <div class="bulk-email-w">
            <div class="sp-container container  bulk-sms-w">
              <div class="sp-container-fluid  ">
                <div class="p-grid">
                  <div class="p-md-8">
                    <h1 class="title-s1 main-heading">
                      Bulk <span>Voice Calls</span>
                    </h1>
                    <p class="text-xl">
                      Bulk voice call services enable you to broadcast
                      pre-recorded messages to thousands or even millions of
                      recipients simultaneously. Whether you want to inform your
                      customers about a special promotion, alert citizens about an
                      emergency, or keep your members updated, bulk voice calls
                      offer an ideal solution.
                    </p>
                  </div>
                  <div class="col-md-6"></div>
                </div>

                <div class="p-grid sp-card1 promotional-sms">
                  <div class="p-md-6">
                    <div class="sp-w70">
                      <h1 class="title-s2 main-heading ">
                        Broadcast Voice message
                      </h1>
                      <p class="sp-text1">
                        A broadcast voice message, often referred to as a voice broadcast or a voice message broadcast, is a communication method that allows a person or organization to send a pre-recorded voice message to a large group of recipients simultaneously
                      </p>
                    </div>
                  </div>
                </div>
                <div class="p-grid sp-card1 transactional-sms">
                  <div class="p-md-6">
                    <div class="sp-w70">
                      <h2 class="ma-mt50 main-heading">
                        IVR Calls (or Surveys)
                      </h2>
                      <p class="sp-text1">
                        Voice broadcasting systems allows to track recipient responses.
                        For example, recipients can press a specific key on their phone to acknowledge receipt. We can capture the user inputs and display them in graphical represention.
                      </p>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section class="bulk-sms-w">
            <div class="sp-container container  ">
              <div class="sp-container-fluid ">
                <div class="p-grid">
                  <div class="p-md-12">
                    <h1 class="title-s1 main-heading">
                      Bulk <span>Email</span>
                    </h1>
                    <p class="sp-text1">
                      Bulk email is the act of sending one email campaign to a
                      large group of people at once. Transactional messages,
                      marketing messages, newsletters, updates, coupons, and
                      invitations typically comprise bulk emails.
                    </p>
                    <br />
                    <p class="sp-text1">
                      Mass email or email blasts, bulk emails focus on sending
                      one central message to a large group of subscribers. All
                      you need is a list of opted-in subscribers and an email
                      marketing platform, like {this.props.orgName}.
                    </p>
                  </div>
                  <div class="p-md-4"></div>
                </div>
              </div>
            </div>
          </section>
          <div class="bulk-email-w">
            <div class="sp-container container sp-container-fluid sp-p15">
              {/* <h2 class="main-heading">Missed Call Services</h2> */}
              <h1 class="title-s1 main-heading">
                <span>Missed Call</span> Services
              </h1>
              <div class="p-grid">
                <div class="p-md-8">
                  <p class="sp-text2">
                    missed call services are a unique and cost-effective
                    communication strategy commonly used in various parts of the
                    world, especially in emerging markets. This approach involves
                    using a specific phone number for people to give a missed
                    call, and in return, they receive valuable information or
                    services
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="sp-container container sp-container-fluid sp-p15">
            <h1 class="title-s1 main-heading">
              <span>Reseller</span> Panel
            </h1>
            <div class="p-grid">
              <div class="p-md-8">
                <p class="sp-text2">
                  A reseller SMS panel, also known as a white-label SMS platform or SMS reseller program, is a service that allows individuals or businesses to resell SMS messaging services under their own brand.
                </p>
                <p class="sp-text2">
                  We are offering a full fledged reseller panel with customized pricing, customized theme at no cost. Just focuss on the business not on the platform. We will take care of platform.
                </p>
              </div>
            </div>
          </div>
          <section class="sendshortly-sounds-w">
            <div class="sp-container container ">
              <div class="sp-container-fluid sounds-section">
                <div class="p-grid sp-no-pm">
                  <div class="p-md-12">
                    <h1 class="title-s1 main-heading">
                      {this.props.orgName} <span>Sounds</span>
                    </h1>
                    <p class="sp-text1">
                      {this.props.orgName} is a Bulk SMS/Email service provider
                      that hepls you in communicating to massive sms,mails and
                      voice sms. we came forward to strive your trouble. we
                      provide services like Transactional, Promotinal SMS, DND
                      open route,voice sms,bulk email.
                    </p>
                    <p class="sp-text1">
                      We are cloud based service providers with 100% uptime and
                      security.
                    </p>
                    <p class="sp-text1">
                      We use smart algorithm to deliver your SMS/Email.
                    </p>
                    <p class="sp-text1">We assure to deliver at 99.99%.</p>
                    <p class="sp-text1">
                      We Provide Read Reciepts of EMail and Delivery Reports of
                      SMS.
                    </p>
                    <p class="sp-text1">
                      Live Reports for voice campaigns.
                    </p>
                    <p class="sp-text1">
                      Secured reseller panel with landing page at no cost.
                    </p>
                  </div>
                  <div class="p-md-6"></div>
                </div>
              </div>
            </div>
          </section>

          <section class="why-sendshortly-w">
            <div class="sp-container container  ">
              <div class="sp-container-fluid  why-sendshortly">
                <div class="p-grid sp-no-pm">
                  <div class="p-md-6">
                    <h1 class="title-s1 main-heading ">Why Us?</h1>
                    <p class="sp-text1">
                      Our vision is to be a reliable to your requirements
                      through our service and stand out in the industry.
                      Furtherly, we want to offer excellent services with the
                      strength of our whole ability with innovative thing.
                    </p>
                    <br />
                    <ul class="sp-text1">
                      <li>Powerfull Compaign System</li>
                      <li>Real time reports</li>
                      <li>Quick, Flexible & Scalable APIs</li>
                      <li>Best delivery report</li>
                      <li>Real time reports</li>
                      <li>Afordable price</li>
                      <li>Easy access</li>
                      <li>Great Support</li>
                      <li>Free URL shortener</li>
                      <li>Safe and secure service provider</li>
                    </ul>
                  </div>

                  <div class="p-md-6"></div>
                </div>
              </div>
            </div>
          </section>
          <div class="sp-container container pricing-contianer-w">
            <div class="sp-container-fluid  pricing-contianer">
              <div class="p-grid">
                <div class="p-md-12">
                  <h1 class="title-s1 main-heading ">Pricing</h1>
                  <p class="sp-text1">
                    Choose best plan that fulfill your requirements. No hidden
                    charges
                  </p>
                  <h2 class="pricing-type">Sms Plans</h2>
                  <p class="plans-txt sp-text1">
                    Pay only for SMS and get at no cost
                  </p>
                  <p></p>

                  {smsPricings && (
                    <div class="container pricing-contianer">
                      <div className="p-grid">
                        <div className="p-col-12 p-md-3 p-sm-6">
                          <div className="pricingTable">
                            <div className="pricingTable-header">
                              <i className="fa fa-adjust"></i>
                              <div className="price-value">
                                {" "}
                                {formatter.format(
                                  (2000 * smsPricings["p2000"]).toFixed(0)
                                )}{" "}
                                <span className="quantity">+ GST 18%</span>
                              </div>
                            </div>
                            {/* <!-- <h3 className="heading">Welcome</h3> --> */}
                            <div className="pricing-content">
                              <ul>
                                <li>
                                  <b>2,000</b> SMS
                                </li>
                                <li>
                                  <b>{smsPricings["p2000"]}</b> per 1 SMS
                                </li>
                                <li>
                                  <b>Unlimited</b> Validity
                                </li>
                                <li>
                                  <b>24/7</b> Support
                                </li>
                                <li>
                                  <b>Free</b> SMS{" "}
                                </li>
                                <li>
                                  <b>Personalize</b> Bulk Sends
                                </li>
                                <li>
                                  <b>Hight priority</b> Routes
                                </li>
                              </ul>
                            </div>
                            <div className="pricingTable-signup">
                              <Link to="/login">sign up</Link>
                            </div>
                          </div>
                        </div>
                        <div className="p-col-12 p-md-3 p-sm-6">
                          <div className="pricingTable blue">
                            <div className="pricingTable-header">
                              <i className="fa fa-cube"></i>
                              <div className="price-value">
                                {" "}
                                {formatter.format(
                                  (5000 * smsPricings["p5000"]).toFixed(0)
                                )}{" "}
                                <span className="quantity">+ GST 18%</span>
                              </div>
                            </div>
                            {/* <!-- <h3 className="heading">₹ 1298 Total</h3> --> */}
                            <div className="pricing-content">
                              <ul>
                                <li>
                                  <b>5,000</b> SMS{" "}
                                </li>
                                <li>
                                  <b>{smsPricings["p5000"]}</b> per 1 SMS
                                </li>
                                <li>
                                  <b>Unlimited</b> Validity
                                </li>
                                <li>
                                  <b>24/7</b> Support
                                </li>
                                <li>
                                  <b>Free</b> SMS{" "}
                                </li>
                                <li>
                                  <b>Personalize</b> Bulk Sends
                                </li>
                                <li>
                                  <b>Hight priority</b> Routes
                                </li>
                              </ul>
                            </div>
                            <div className="pricingTable-signup">
                              <Link to="/login">sign up</Link>
                            </div>
                          </div>
                        </div>
                        <div className="p-col-12 p-md-3 p-sm-6">
                          <div className="pricingTable green">
                            <div className="pricingTable-header">
                              <i className="fa fa-briefcase"></i>
                              <div className="price-value">
                                {" "}
                                {formatter.format(
                                  (10000 * smsPricings["p10000"]).toFixed(0)
                                )}{" "}
                                <span className="quantity">+ GST 18%</span>
                              </div>
                            </div>
                            {/* <!-- <h3 className="heading">Business</h3> --> */}
                            <div className="pricing-content">
                              <ul>
                                <li>
                                  <b>10,000</b> SMS
                                </li>
                                <li>
                                  <b>{smsPricings["p10000"]}</b> per 1 SMS
                                </li>
                                <li>
                                  <b>Unlimited</b> Validity
                                </li>
                                <li>
                                  <b>24/7</b> Support
                                </li>
                                <li>
                                  <b>Free</b> SMS{" "}
                                </li>
                                <li>
                                  <b>Personalize</b> Bulk Sends
                                </li>
                                <li>
                                  <b>Hight priority</b> Routes
                                </li>
                              </ul>
                            </div>
                            <div className="pricingTable-signup">
                              <Link to="/login">sign up</Link>
                            </div>
                          </div>
                        </div>

                        <div className="p-col-12 p-md-3 p-sm-6">
                          <div className="pricingTable red">
                            <div className="pricingTable-header">
                              <i className="fa fa-diamond"></i>
                              <div className="price-value">
                                {" "}
                                {formatter.format(
                                  (100000 * smsPricings["p100000"]).toFixed(0)
                                )}{" "}
                                <span className="quantity">+ GST 18%</span>
                              </div>
                            </div>
                            {/* <!-- <h3 className="heading">Extra</h3> --> */}
                            <div className="pricing-content">
                              <ul>
                                <li>
                                  <b>1,00,000</b> SMS{" "}
                                </li>
                                <li>
                                  <b>{smsPricings["p100000"]}</b> per 1 SMS
                                </li>
                                <li>
                                  <b>Unlimited</b> Validity
                                </li>
                                <li>
                                  <b>24/7</b> Support
                                </li>
                                <li>
                                  <b>Free</b> SMS{" "}
                                </li>
                                <li>
                                  <b>Personalize</b> Bulk Sends
                                </li>
                                <li>
                                  <b>Hight priority</b> Routes
                                </li>
                              </ul>
                            </div>
                            <div className="pricingTable-signup">
                              <Link to="/login">sign up</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <h2 class="pricing-type">Voice Plans</h2>
                  <p class="plans-txt sp-text1">
                    Pay only for on answered calls
                  </p>
                  <p></p>

                  {voicePricings && (
                    <div class="container pricing-contianer">
                      <div className="p-grid">
                        <div className="p-col-12 p-md-3 p-sm-6">
                          <div className="pricingTable">
                            <div className="pricingTable-header">
                              <i className="fa fa-adjust"></i>
                              <div className="price-value">
                                {" "}
                                {formatter.format(
                                  (2000 * voicePricings["p2000"]).toFixed(0)
                                )}{" "}
                                <span className="quantity">+ GST 18%</span>
                              </div>
                            </div>
                            {/* <!-- <h3 className="heading">Welcome</h3> --> */}
                            <div className="pricing-content">
                              <ul>
                                <li>
                                  <b>2,000</b> voice calls
                                </li>
                                <li>
                                  <b>{voicePricings["p2000"]}</b> per 1 sec per
                                  call
                                </li>
                                <li>
                                  <b>Unlimited</b> Validity
                                </li>
                                <li>
                                  <b>24/7</b> Support
                                </li>
                                <li>
                                  <b>Free</b> Voice APIs{" "}
                                </li>
                                <li>
                                  <b>Personalize</b> Bulk Sends
                                </li>
                                <li>
                                  <b>Hight priority</b> Routes
                                </li>
                                <li>
                                  <b>Time </b>9 AM to 9 PM
                                </li>
                                <li>
                                  <b>Type</b> Outbound,Inbound
                                </li>
                                <li>
                                  <b>Missed call Services</b>
                                </li>
                                <li>
                                  <b>IVR Survey</b>
                                </li>
                                <li>
                                  <b>DTMF Capturing</b>
                                </li>

                                <li>
                                  <b>NON DND Promotional</b>
                                </li>

                              </ul>
                            </div>
                            <div className="pricingTable-signup">
                              <Link to="/login">sign up</Link>
                            </div>
                          </div>
                        </div>
                        <div className="p-col-12 p-md-3 p-sm-6">
                          <div className="pricingTable blue">
                            <div className="pricingTable-header">
                              <i className="fa fa-cube"></i>
                              <div className="price-value">
                                {" "}
                                {formatter.format(
                                  (5000 * voicePricings["p5000"]).toFixed(0)
                                )}{" "}
                                <span className="quantity">+ GST 18%</span>
                              </div>
                            </div>
                            {/* <!-- <h3 className="heading">₹ 1298 Total</h3> --> */}
                            <div className="pricing-content">
                              <ul>
                                <li>
                                  <b>5,000</b> voice calls{" "}
                                </li>
                                <li>
                                  <b>{voicePricings["p5000"]}</b> per 1 sec per
                                  call
                                </li>
                                <li>
                                  <b>Unlimited</b> Validity
                                </li>
                                <li>
                                  <b>24/7</b> Support
                                </li>
                                <li>
                                  <b>Free</b> Voice APIs{" "}
                                </li>
                                <li>
                                  <b>Personalize</b> Bulk Sends
                                </li>
                                <li>
                                  <b>Hight priority</b> Routes
                                </li>
                                <li>
                                  <b>Time </b>9 AM to 9 PM
                                </li>
                                <li>
                                  <b>Type</b> Outbound,Inbound
                                </li>
                                <li>
                                  <b>Missed call Services</b>
                                </li>
                                <li>
                                  <b>IVR Survey</b>
                                </li>
                                <li>
                                  <b>DTMF Capturing</b>
                                </li>

                                <li>
                                  <b>NON DND Promotional</b>
                                </li>

                              </ul>
                            </div>
                            <div className="pricingTable-signup">
                              <Link to="/login">sign up</Link>
                            </div>
                          </div>
                        </div>
                        <div className="p-col-12 p-md-3 p-sm-6">
                          <div className="pricingTable green">
                            <div className="pricingTable-header">
                              <i className="fa fa-briefcase"></i>
                              <div className="price-value">
                                {" "}
                                {formatter.format(
                                  (10000 * voicePricings["p10000"]).toFixed(0)
                                )}{" "}
                                <span className="quantity">+ GST 18%</span>
                              </div>
                            </div>
                            {/* <!-- <h3 className="heading">Business</h3> --> */}
                            <div className="pricing-content">
                              <ul>
                                <li>
                                  <b>10,000</b> voice calls
                                </li>
                                <li>
                                  <b>{voicePricings["p10000"]}</b> per 1 sec per
                                  call
                                </li>
                                <li>
                                  <b>Unlimited</b> Validity
                                </li>
                                <li>
                                  <b>24/7</b> Support
                                </li>
                                <li>
                                  <b>Free</b> Voice APIs{" "}
                                </li>
                                <li>
                                  <b>Personalize</b> Bulk Sends
                                </li>
                                <li>
                                  <b>Hight priority</b> Routes
                                </li>
                                <li>
                                  <b>Time </b>9 AM to 9 PM
                                </li>
                                <li>
                                  <b>Type</b> Outbound,Inbound
                                </li>
                                <li>
                                  <b>Missed call Services</b>
                                </li>
                                <li>
                                  <b>IVR Survey</b>
                                </li>
                                <li>
                                  <b>DTMF Capturing</b>
                                </li>

                                <li>
                                  <b>NON DND Promotional</b>
                                </li>

                              </ul>
                            </div>
                            <div className="pricingTable-signup">
                              <Link to="/login">sign up</Link>
                            </div>
                          </div>
                        </div>

                        <div className="p-col-12 p-md-3 p-sm-6">
                          <div className="pricingTable red">
                            <div className="pricingTable-header">
                              <i className="fa fa-diamond"></i>
                              <div className="price-value">
                                {" "}
                                {formatter.format(
                                  (100000 * voicePricings["p100000"]).toFixed(0)
                                )}{" "}
                                <span className="quantity">+ GST 18%</span>
                              </div>
                            </div>
                            {/* <!-- <h3 className="heading">Extra</h3> --> */}
                            <div className="pricing-content">
                              <ul>
                                <li>
                                  <b>1,00,000</b> voice calls{" "}
                                </li>
                                <li>
                                  <b>{voicePricings["p100000"]}</b>per 1 sec per
                                  call
                                </li>
                                <li>
                                  <b>Unlimited</b> Validity
                                </li>
                                <li>
                                  <b>24/7</b> Support
                                </li>
                                <li>
                                  <b>Free</b> Voice APIs{" "}
                                </li>
                                <li>
                                  <b>Personalize</b> Bulk Sends
                                </li>
                                <li>
                                  <b>Hight priority</b> Routes
                                </li>
                                <li>
                                  <b>Time </b>9 AM to 9 PM
                                </li>
                                <li>
                                  <b>Type</b> Outbound,Inbound
                                </li>
                                <li>
                                  <b>Missed call Services</b>
                                </li>
                                <li>
                                  <b>IVR Survey</b>
                                </li>
                                <li>
                                  <b>DTMF Capturing</b>
                                </li>

                                <li>
                                  <b>NON DND Promotional</b>
                                </li>

                              </ul>
                            </div>
                            <div className="pricingTable-signup">
                              <Link to="/login">sign up</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <h2 class="ma-mt50 pricing-type">Email Plans</h2>
                  <p class="sp-text1">
                    Pay only for email delivery charges. No limit for emails
                    list.
                  </p>

                  {emailPricings && (
                    <div class="container pricing-contianer">
                      <div className="p-grid">
                        <div className="p-col-12 p-md-3 p-sm-6">
                          <div className="pricingTable">
                            <div className="pricingTable-header">
                              <i className="fa fa-adjust"></i>
                              <div className="price-value">
                                {" "}
                                {formatter.format(
                                  (2000 * emailPricings["p2000"]).toFixed(0)
                                )}{" "}
                                <span className="quantity">+ GST 18%</span>
                              </div>
                            </div>
                            {/* <!-- <h3 className="heading">Welcome</h3> --> */}
                            <div className="pricing-content">
                              <ul>
                                <li>
                                  <b>2,000</b> Emails
                                </li>
                                <li>
                                  <b>{emailPricings["p2000"]}</b> per 1 Email
                                </li>
                                <li>
                                  <b>Unlimited</b> Validity
                                </li>
                                <li>
                                  <b>24/7</b> Support
                                </li>
                                <li>
                                  <b>Free</b> Email APIs
                                </li>
                                <li>
                                  <b>Personalize</b> Bulk Sends
                                </li>
                                <li>
                                  <b>Hight priority</b> Routes
                                </li>
                              </ul>
                            </div>
                            <div className="pricingTable-signup">
                              <Link to="/login">sign up</Link>
                            </div>
                          </div>
                        </div>
                        <div className="p-col-12 p-md-3 p-sm-6">
                          <div className="pricingTable blue">
                            <div className="pricingTable-header">
                              <i className="fa fa-cube"></i>
                              <div className="price-value">
                                {" "}
                                {formatter.format(
                                  (5000 * emailPricings["p5000"]).toFixed(0)
                                )}{" "}
                                <span className="quantity">+ GST 18%</span>
                              </div>
                            </div>
                            {/* <!-- <h3 className="heading">₹ 1298 Total</h3> --> */}
                            <div className="pricing-content">
                              <ul>
                                <li>
                                  <b>5,000</b> Emails
                                </li>
                                <li>
                                  <b>{emailPricings["p5000"]}</b> per 1 Email
                                </li>
                                <li>
                                  <b>Unlimited</b> Validity
                                </li>
                                <li>
                                  <b>24/7</b> Support
                                </li>
                                <li>
                                  <b>Free</b> Email APIs
                                </li>
                                <li>
                                  <b>Personalize</b> Bulk Sends
                                </li>
                                <li>
                                  <b>Hight priority</b> Routes
                                </li>
                              </ul>
                            </div>
                            <div className="pricingTable-signup">
                              <Link to="/login">sign up</Link>
                            </div>
                          </div>
                        </div>
                        <div className="p-col-12 p-md-3 p-sm-6">
                          <div className="pricingTable green">
                            <div className="pricingTable-header">
                              <i className="fa fa-briefcase"></i>
                              <div className="price-value">
                                {" "}
                                {formatter.format(
                                  (10000 * emailPricings["p10000"]).toFixed(0)
                                )}{" "}
                                <span className="quantity">+ GST 18%</span>
                              </div>
                            </div>
                            {/* <h3 className="heading">Business</h3>  */}
                            <div className="pricing-content">
                              <ul>
                                <li>
                                  <b>10,000</b> Emails
                                </li>
                                <li>
                                  <b>{emailPricings["p10000"]}</b> per 1 Email
                                </li>
                                <li>
                                  <b>Unlimited</b> Validity
                                </li>
                                <li>
                                  <b>24/7</b> Support
                                </li>
                                <li>
                                  <b>Free</b> Email APIs
                                </li>
                                <li>
                                  <b>Personalize</b> Bulk Sends
                                </li>
                                <li>
                                  <b>Hight priority</b> Routes
                                </li>
                              </ul>
                            </div>
                            <div className="pricingTable-signup">
                              <Link to="/login">sign up</Link>
                            </div>
                          </div>
                        </div>

                        <div className="p-col-12 p-md-3 p-sm-6">
                          <div className="pricingTable red">
                            <div className="pricingTable-header">
                              <i className="fa fa-diamond"></i>
                              <div className="price-value">
                                {" "}
                                {formatter.format(
                                  (100000 * emailPricings["p100000"]).toFixed(0)
                                )}{" "}
                                <span className="quantity">+ GST 18%</span>
                              </div>
                            </div>
                            {/* <h3 className="heading">Extra</h3>  */}
                            <div className="pricing-content">
                              <ul>
                                <li>
                                  <b>1,00,000</b> Emails
                                </li>
                                <li>
                                  <b>{emailPricings["p100000"]}</b> per 1 Email
                                </li>
                                <li>
                                  <b>Unlimited</b> Validity
                                </li>
                                <li>
                                  <b>24/7</b> Support
                                </li>
                                <li>
                                  <b>Free</b> Email APIs
                                </li>
                                <li>
                                  <b>Personalize</b> Bulk Sends
                                </li>
                                <li>
                                  <b>Hight priority</b> Routes
                                </li>
                              </ul>
                            </div>
                            <div className="pricingTable-signup">
                              <Link to="/login">sign up</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <section class="faqs-contianer-w ">
            <div class="container">
              <div class="sp-container-fluid  faqs-contianer">
                <h1 class="title-s1 main-heading">FAQ's</h1>
                <Accordion>
                  <AccordionTab header="What is the purpose of bullk sms service?">
                    <p>
                      Its uses are endless. Bulk SMS can be deployed wherever we
                      need to build an instant connection and convey urgent
                      information.
                    </p>
                  </AccordionTab>
                  <AccordionTab header="How many messages i can send per Campaign">
                    <p>
                      There’s no limit on the number of messages you can send
                      per campaign.
                    </p>
                  </AccordionTab>
                  <AccordionTab header="Does you provide API's ?">
                    <p>yes, you will get access to APIs once you signup.</p>
                  </AccordionTab>
                </Accordion>

                {/* 
                            <div class="p-grid">
                                <div class="p-md-12">
                                    <h1 class="title-s1 main-heading">FAQ's</h1>
                                    <div id="accordion" class="sp-accordian">
                                        <div class="card">
                                            <div class="card-header" id="headingOne">

                                                <h5 class="heading-s1" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                                                    aria-controls="collapseOne">
                                                    What is the purpose of bullk sms service?
                                                    <span>+</span>
                                                </h5>

                                            </div>

                                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                                <div class="card-body">
                                                    Its uses are endless. Bulk SMS can be deployed wherever we need to build an instant connection and
                                                    convey urgent information.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header" id="headingTwo">
                                                <h5 class="heading-s1 collapsed" data-toggle="collapse" data-target="#collapseTwo"
                                                    aria-expanded="false" aria-controls="collapseTwo">
                                                    How many messages i can send per Campaign
                                                    <span>+</span>
                                                </h5>
                                            </div>
                                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                                <div class="card-body">
                                                    There’s no limit on the number of messages you can send per campaign.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header" id="headingThree">
                                                <h5 class="heading-s1 collapsed" data-toggle="collapse" data-target="#collapseThree"
                                                    aria-expanded="false" aria-controls="collapseThree">
                                                    Does you provide API's ?
                                                    <span>+</span>
                                                </h5>
                                            </div>
                                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                                <div class="card-body">
                                                    yes, you will get access to APIs once you signup.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              </div>
            </div>
          </section>
          <section class="case-study-contianer-w ">
            <div class="sp-container container ">
              <div class="sp-container-fluid ">
                <h1 class="title-s1 " style={{ color: "white" }}>
                  Case Studies
                </h1>
                <p class="">
                  There are many examples of how our customers use Our Services
                  in their daily practice. There are many different companies
                  and departments that use Our Services to assist their business
                  communication and grow their business. We served the needs of
                  nationally recognized clients. There are many different
                  companies/sectors/organization using messages to aid and
                  enhance their business advisement, marketing and
                  communications. If you would like to know how some of these
                  companies/sectors/organizations are using our services, then
                  please do take a look at the case studies below by clicking
                  on.
                </p>
                <div>
                  <div class="read-more">
                    <Link to="/case-studies" className="">
                      Know More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </ClientHeader>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  userType: state?.user?.userType,
  authenticated: state?.user?.authenticated,
  orgName: state?.orgData?.orgName,
  smsPricings: state?.orgData?.smsPricings,
  emailPricings: state?.orgData?.emailPricings,
  voicePricings: state?.orgData?.voicePricings,
  orgName: state?.orgData?.orgName,
  bannerImage: state?.orgData?.bannerImage,
});

export default connect(mapStateToProps, {})(withRouter(HomePageClient));
